//extracted by mini-css-extract-plugin
export default {"container":"styles_container__3zbOj","skeletonItem":"styles_skeletonItem__aRZlh"};;